export const FILE_INPUT_IDS = {
    uploadDSLInputID: 'UPLOAD_DSL_INPUT_ID',
};
